// @flow
import classnames from 'classnames';
import classify from '@src/utils/typestyle';

export const columnWidths: { [string]: number } = {
  compare: 75,
  shape: 98,
  carat: 59,
  cut: 89,
  color: 42,
  clarity: 66,
  polish: 90,
  symmetry: 95,
  fluorescence: 106,
  depth: 66,
  table: 58,
  lw_ratio: 66,
  price: 90
};

const columnHeaders = [
  { name: 'Compare', key: 'compare', width: columnWidths.compare },
  { name: 'Shape', key: 'shape', width: columnWidths.shape },
  { name: 'Carat', key: 'carat', width: columnWidths.carat },
  { name: 'Cut', key: 'cut', width: columnWidths.cut },
  { name: 'Color', key: 'color', width: columnWidths.color },
  { name: 'Clarity', key: 'clarity', width: columnWidths.clarity },
  { name: 'Polish', key: 'polish', width: columnWidths.polish },
  { name: 'Symmetry', key: 'symmetry', width: columnWidths.symmetry },
  {
    name: 'Fluorescence',
    key: 'fluorescence',
    width: columnWidths.fluorescence
  },
  { name: 'Depth', key: 'depth', width: columnWidths.depth },
  { name: 'Table', key: 'table', width: columnWidths.table },
  { name: 'LW Ratio', key: 'lw_ratio', width: columnWidths.lw_ratio },
  { name: 'Price', key: 'price', width: columnWidths.price }
];

const classes = classify({
  headerContainer: {
    width: '1000px',
    maxWidth: '100%',
    height: '50px',
    background: '#21528d',
    fontSize: '14px',
    color: 'white'
  },
  headerItem: {
    position: 'relative',
    float: 'left',
    height: '50px',
    textAlign: 'center',
    lineHeight: '50px',
    cursor: 'pointer',
    $nest: {
      '&:hover': {
        background: '#193c67'
      }
    }
  },
  caret: {
    position: 'absolute',
    left: 'calc(50% - 3px)',
    bottom: '2px',
    color: '#e1a913'
  },
  priceCaret: {
    right: '40px !important'
  },
  price: {
    paddingRight: 29,
    textAlign: 'right',
    minWidth: columnWidths.price
  }
});

type PropsType = {
  onItemClick: (headerKey: string) => void,
  sortedColumn: string | void,
  sortDirection: string | void,
  tableMinimumWidth: number,
  responsiveColumnClasses: { [string]: string },
  allowCompare: boolean
};

export default class DiamondDatagridHeader extends React.Component<PropsType> {
  static defaultProps = {
    selectedFilters: []
  };

  render() {
    const columnBreakpointClasses = this.props.responsiveColumnClasses;
    const tableMinimumWidth = this.props.tableMinimumWidth;

    return (
      <div
        className={classes.headerContainer}
        style={{ minWidth: tableMinimumWidth }}
      >
        {columnHeaders.map((column, i) => {
          if (column.key === 'compare' && !this.props.allowCompare) return null;
          return (
            <div
              key={column.key}
              className={classnames(classes.headerItem, classes[column.key], columnBreakpointClasses[column.key])}
              style={column.key === 'price' ? {} : {width: column.width}}
              onClick={() => this.props.onItemClick(column.key)}
            >
              {column.name}
              {this.props.sortedColumn?.indexOf(column.key) >= 0 ? (
                <i
                  className={classnames('fa', classes.caret, {
                    'fa-caret-up': this.props.sortDirection === 'desc',
                    'fa-caret-down': this.props.sortDirection === 'asc',
                    [classes.priceCaret]: this.props.sortedColumn === 'price'
                  })}
                  aria-hidden='true'
                />
              ) : null}
            </div>
          );
        })}
      </div>
    );
  }
}
